import actions from './constants';

export const updateCurrentCohortPermissions = (code, permissions) => ({
  type: actions.UPDATE_CURRENT_COHORT_PERMISSIONS,
  code,
  permissions,
});

export const fetchCohortMembers = (category, code, assignable, filter) => ({
  type: actions.FETCH_COHORT_MEMBERS,
  category,
  code,
  assignable,
  filter,
});

export const updateCohortMembersProperties = (category, code, assignable, properties) => ({
  type: actions.UPDATE_COHORT_MEMBERS_PROPERTIES,
  category,
  code,
  assignable,
  properties,
});

export const showShareCohort = (category, code) => ({
  type: actions.SHOW_SHARE_COHORT,
  category,
  code,
});

export const hideShareCohort = (category, code) => ({
  type: actions.HIDE_SHARE_COHORT,
  category,
  code,
});

export const showCohortMembers = (category, code, results, resultsCount, assignable) => ({
  type: actions.SHOW_COHORT_MEMBERS,
  category,
  code,
  results,
  resultsCount,
  assignable,
});

export const showCohortMembersError = (category, code, error, assignable) => ({
  type: actions.SHOW_COHORT_MEMBERS_ERROR,
  category,
  code,
  error,
  assignable,
});

export const updateShareCohortProperties = (properties) => ({
  type: actions.UPDATE_SHARE_COHORT_PROPERTIES,
  properties,
});

export const addCohortMembers = (category, code) => ({
  type: actions.ADD_COHORT_MEMBERS,
  category,
  code,
});

export const removeCohortMember = (category, code, memberID) => ({
  type: actions.REMOVE_COHORT_MEMBER,
  category,
  code,
  memberID,
});

export const updateCohortMemberPermissions = (category, code, memberID, permissions) => ({
  type: actions.UPDATE_COHORT_MEMBER_PERMISSIONS,
  category,
  code,
  memberID,
  permissions,
});

export const shareCohort = () => ({
  type: actions.SHARE_COHORT,
});

export const shareCohortSuccess = (code, name, members, destroy) => ({
  type: actions.SHARE_COHORT_SUCCESS, code, name, members, destroy,
});

export const shareCohortError = (code, name, members) => ({
  type: actions.SHARE_COHORT_ERROR, code, name, members,
});
